import * as moment from 'moment';
import { Toro } from '../common/enumerations';
import { PaginationMetaData } from './pagination-meta-data.model';

export class DevicesResponse{
    public Devices:DependentDevice[];
    public PaginationMetaData: PaginationMetaData;
}

export class DependentDevice {
    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);

            if (json.WhenCreated) {
                this.WhenCreated = new Date(json.WhenCreated);
            }

            if (json.WhenLastUpdated) {
                this.WhenLastUpdated = new Date(json.WhenLastUpdated);
            }

            if (json.WhenLastKnownCommunication) {
                this.WhenLastKnownCommunication = new Date(json.WhenLastKnownCommunication);
            }
        }
    }

    public LocationId: number;
    public CommCardId: number;
    public CommCardUId: string;
    public IsProgrammable: boolean;
    public Name: string;
    public Description: string;
    public CommunicationPin: number;
    public Id: number;
    public UId: string;
    public WhenCreated: Date;
    public WhenLastUpdated: Date;
    public FirmwareVersion: number;
    public BootVersion: number;
    public HardwareVersion: number;
    public AccountId: number;
    public DeviceGroupId: number;
    public SecretId: string;
    public OrdinalPosition: number;
    public DeviceTypeId: number;
    public Device_Type: string;
    public Scene: string;
    public ParentId: number;
    public BaseId: number;
    public IsRecognized: boolean;
    public WhenLastKnownCommunication: Date;
    public FixtureType: number;
    public RepeatMode: number;
    get SmartId(): number {
        let deviceType = this.UId.substring(8, 10);

        let deviceTypeId = parseInt(deviceType, 16);

        if (deviceTypeId === Toro.DeviceTypeId.MAGNETO) {
            return parseInt(this.UId.substring(8), 16);
        }
        else {
            return parseInt(this.UId.substring(10), 16);
        }

    }

    get getStatusText(): string {
        const now = moment();
        const timeDifference = moment.duration(now.diff(moment(this.WhenLastKnownCommunication)));

        if (timeDifference.asDays() > 10) {
            return 'unk';
        }
        else if (timeDifference.asMinutes() < 1) {
            return 'just now';
        }
        else if (timeDifference.asHours() < 1) {
            return `${Math.floor(timeDifference.asMinutes())} min ago`;
        }
        else if (timeDifference.asDays() < 1) {
            return `${Math.floor(timeDifference.asHours())} hrs ${Math.floor(timeDifference.asMinutes()) % 60} min ago`;
        }
        else if (timeDifference.asDays() === 1) {
            return '1 day ago';
        }
        else {
            return `${Math.floor(timeDifference.asDays())} days ago`;
        }
    }

    get getStatusDisplayColor(): string {

        const now = moment();
        const hoursDifference = moment.duration(now.diff(moment(this.WhenLastKnownCommunication))).asHours();
        if (this.WhenLastKnownCommunication == null) {
            return '#FF0000';
        }

        if (this.DeviceTypeId === Toro.DeviceType.MAGNETO) {
            if (hoursDifference < 72) {
                return '#0B610B';
            }
            else if (hoursDifference > 72 && hoursDifference < 96) {
                return '#FF4000';
            }
            else {
                return '#FF0000';
            }
        }
        else {
            if (hoursDifference < 1) // darkest green
            {
                return '#0B610B';
            }
            if (hoursDifference < 2) // lighter green
            {
                return '#088A08';
            }

            if (hoursDifference < 3) // lighter green
            {
                return '#04B404';
            }

            if (hoursDifference < 4) // lighter green
            {
                return '#01DF01';
            }

            if (hoursDifference < 5) // lighter green
            {
                return '#00FF00';
            }

            if (hoursDifference < 6) // lighter green
            {
                return '#2EFE2E';
            }

            if (hoursDifference < 7) // lighter green
            {
                return '#58FA58';
            }

            if (hoursDifference < 8) // lightest green
            {
                return '#81F781';
            }

            if (hoursDifference < 9) // yellow
            {
                return '#F7FE2E';
            }
            if (hoursDifference < 10) // light orange
            {
                return '#FFBF00';

            }
            if (hoursDifference < 11) // Orange
            {
                return '#FF8000';
            }

            if (hoursDifference < 12) // Orange-red
            {
                return '#FF4000';
            }

            if (hoursDifference < 13) // light-red
            {
                return '#FF0000';
            }
        }

        return '#DF0101';
    }
}
